import { useState } from "react";
import { useQuery } from "@apollo/client";
import usePropertyChangeEffect from "@cofano/cck/hooks/usePropertyChangeEffect";
import { GetCharterForSideviewerDocument, GetCharterForSideviewerQuery } from "__generated__/view/charters/graphql/charter.queries.generated";
import { ChildProps } from "types/commons";

export type CharterFromCharterSideviewer = ChildProps<GetCharterForSideviewerQuery, "charter">;

const useCharterSideviewer = ({
	defaultCharterId,
}: {
	defaultCharterId: number | null;
}) => {
	const [ selectedId, setSelectedId ] = useState<number | null>(defaultCharterId);

	const { data, previousData, loading, refetch } = useQuery(GetCharterForSideviewerDocument, {
		variables: {
			id: selectedId ?? 0,
		},
		skip: !selectedId,
	});

	const fetchCharter = (id: number) => {
		if (id === selectedId) {
			refetch();
		} else {
			setSelectedId(id);
		}
	};

	usePropertyChangeEffect(() => {
		setSelectedId(defaultCharterId);
	}, [ defaultCharterId ]);

	const selectedCharter = data?.charter ?? previousData?.charter ?? null;

	return {
		selectedCharter,
		loading,
		fetchCharter,
	};
};

export default useCharterSideviewer;
